import React, { forwardRef } from 'react';
import { Link, Button, CheckboxFilter, View, colors } from '@fairygodboss/ui';
import { CompaniesFilter } from './CompaniesFilters';
import { LocationFilter } from './LocationFilter';

export const TabletRender = forwardRef(
    (
        {
            bodyRef,
            remoteSelected,
            onRemoteSelect,
            locationsOpen,
            isLocationsOpen,
            locations,
            onLocationSelect,
            hasRemote,
            activeLocations,
            onClearFilters,
            setActiveCompanies,
            activeCompanies,
            isSM,
            setActiveLocations,
            isAuthenticatedUser,
            companiesOpen,
            companies,
            isCompaniesOpen,
            onCompanySelect,
        },
        ref
    ) => {
        return (
            <View
                display="block"
                p="16px"
                px="12px"
                justifyContent="space-between"
                ref={bodyRef}
            >
                <View
                    display="flex"
                    justifyContent={hasRemote ? 'space-between' : 'flex-start'}
                >
                    {hasRemote ? (
                        <CheckboxFilter
                            checked={remoteSelected}
                            onClick={onRemoteSelect}
                            label="Remote/Flexible"
                        />
                    ) : null}
                    <View mr={hasRemote ? '0px' : '24px'}>
                        <CompaniesFilter
                            ref={ref?.companiesFilterRef}
                            isSM={isSM}
                            companiesOpen={companiesOpen}
                            hasRemote={hasRemote}
                            companies={companies}
                            isCompaniesOpen={isCompaniesOpen}
                            onCompanySelect={onCompanySelect}
                            bodyRef={bodyRef}
                            activeCompanies={activeCompanies}
                        />
                    </View>
                    <div style={{ display: 'none' }}>
                        <LocationFilter
                            ref={ref?.locationFiltersRef}
                            locationsOpen={locationsOpen}
                            isLocationsOpen={isLocationsOpen}
                            locations={locations}
                            onLocationSelect={onLocationSelect}
                            bodyRef={bodyRef}
                            activeLocations={activeLocations}
                            isSM={isSM}
                        />
                    </div>
                    {/* Temp whyle location Filters are disabled */}
                    <Button
                        size="large"
                        variant="secondaryText"
                        onPress={() => {
                            onClearFilters();
                            setActiveCompanies([]);
                            setActiveLocations([]);
                        }}
                    >
                        Clear filters
                    </Button>
                </View>
                <View display="flex" justifyContent="space-between" pt="10px">
                    {/* Temp whyle location Filters are disabled */}
                    {/* <Button
                        size="large"
                        variant="secondaryText"
                        onPress={() => {
                            onClearFilters();
                            setActiveCompanies([]);
                            setActiveLocations([]);
                        }}
                    >
                        Clear filters
                    </Button> */}
                    {isAuthenticatedUser ? (
                        <View
                            pt="14px"
                            css={{
                                'a:visited': {
                                    color: `${colors.primary[60]} !important`,
                                    'div > svg': {
                                        path: {
                                            fill: colors.primary[60],
                                        },
                                    },
                                    'a:hover': {
                                        color: `${colors.primary[80]} !important`,
                                        'div > svg': {
                                            path: {
                                                fill: colors.primary[80],
                                            },
                                        },
                                    },
                                },
                            }}
                        >
                            <Link href="/jobs/saved" icon variant="standalone">
                                Saved Jobs
                            </Link>
                        </View>
                    ) : null}
                </View>
            </View>
        );
    }
);
